/* eslint-disable */
import React from "react";
import { Input,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  InputAdornment, } from "@material-ui/core";
import { Container, Row, Col } from "react-bootstrap";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { Button, useMediaQuery } from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import { Alert } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {CardElement, useStripe, useElements} from '@stripe/react-stripe-js';
const stripes = require("stripe")
import DateFnsUtils from "@date-io/date-fns";
import {
  auth,
  db,
} from "../../Firebase/firebase.js";
import { useHistory } from "react-router-dom";
import ls from "local-storage";
import IconButton from "@material-ui/core/IconButton";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";

import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";
const useStyles = makeStyles(styles);


const stripePromise = loadStripe('pk_test_51IKpVNFoHdU9xtzGTrozxZPGt6GSh3CNi65lUdUWdmTp14gnSfwbAguTFsnZ2Fp58Q6C21untUYF9PugInDPC5Al00JhFUkm7j');


const CARD_OPTIONS = {
	iconStyle: "solid",
	style: {
		base: {
			iconColor: "#c4f0ff",
			color: "#fff",
			fontWeight: 500,
			fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
			fontSize: "16px",
			fontSmoothing: "antialiased",
			":-webkit-autofill": { color: "#fce883" },
			"::placeholder": { color: "#87bbfd" }
		},
		invalid: {
			iconColor: "#ffc7ee",
			color: "#ffc7ee"
		}
	}
}

function EventRegistration() {
  const classes = useStyles();
  let history = useHistory();
  const theme = new useTheme();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  const Ipadpro = useMediaQuery(theme.breakpoints.between("md", "1300"));
  const Laptop = useMediaQuery(theme.breakpoints.up("lg"));
  const Ipad = useMediaQuery(theme.breakpoints.between("700", "870"));
  const [dob, setDOB] = React.useState(new Date());
  const [ageGroup, setAgeGroup] = React.useState("");
  const [registrationDays, setRegDays] = React.useState("");
  const costref= React.useRef("")
  const agegroupref= React.useRef("")
  const regdayref = React.useRef("")
  const nameRef= React.useRef("")
  const emailRef =React.useRef("")
  const addressRef =React.useRef("")
  const phRef =React.useRef("")
  const [confirmationbox, setconfirmationbox] = React.useState(false);
  const [errormessage,setErrormessage]=React.useState(false)
  const [doorcheck,setDoorcheck]=React.useState(false)
  const [mediumcheck,setMediumcheck]=React.useState(false)
 

  React.useEffect(() => {
    if (ls.get("currentcustomer") === "") {
      history.push("/customerlogin")
    } else {
     
    }
  }, []);
  
  const registerEvent =()=>{
    if(nameRef.current.value!==""&& emailRef.current.value!=="" && addressRef.current.value!==""&& phRef.current.value!=="" && costref.current.value!==""){
      
      db.collection("events")
            .where("status", "==", "Open")
            .get()
            .then((snapshot)=>{
              snapshot.forEach((doc) => {
                db.collection("eventRegistration")
              .add({
                name: nameRef.current.value,
                email: emailRef.current.value,
                dob: moment(dob).format("DD-MM-YYYY"),
                address: addressRef.current.value,
                contact: phRef.current.value,
                ageGroup: ageGroup,
                eventId: doc.id,
                uid: ls.get("currentcustomer").uid,
                registrationDays: registrationDays,
                fee: costref.current.value,
              })
              .then(()=>{
                db.collection("eventRegistration").doc(doc.id).set(
                  {
                    docId: doc.id,
                  },
                  { merge: true }
                );
                if (registrationDays === "Both") {
                  
                  db.collection("category")
                    .doc("Door")
                    .collection("tickets")
                    .doc(doc.id)
                    .set({
                      registerationId: doc.id,
                      registerationName: ls.get("currentcustomer").displayName,
                      ticket_count: 1,
                      uid: ls.get("currentcustomer").uid,
                    })
                    .then(()=>{
                        setDoorcheck(true)
                     
                    })
                    .catch((err) => {
                      console.log(err);
                    });

                  db.collection("category")
                    .doc("Medium")
                    .collection("tickets")
                    .doc(doc.id)
                    .set({
                      registerationId: doc.id,
                      registerationName: ls.get("currentcustomer").displayName,
                      ticket_count: 1,
                      uid: ls.get("currentcustomer").uid,
                    })
                    .then(()=>{
                        setMediumcheck(true)
                    })
                    .catch((err)=>{
                      console.log(err)
                    })
                    console.log(doorcheck +"jhk"+ mediumcheck)
                  if(doorcheck===true && mediumcheck===true){
                    setconfirmationbox(true)
                  }
                } else {
                  db.collection("category")
                    .doc("Door")
                    .collection("tickets")
                    .doc(doc.id)
                    .set({
                      registerationId: doc.id,
                      registerationName: ls.get("currentcustomer").displayName,
                      ticket_count: 1,
                      uid: ls.get("currentcustomer").uid,
                    })
                    .then(()=>{
                      setconfirmationbox(true)
                    })
                }
              })
              })
              
            })
    }
    else{
      setErrormessage(true)
    }
    
   
  }

  const CheckoutForm = () => {
    const stripe = useStripe();
    const elements = useElements();
  
    const handleSubmit = async (event) => {
      // Block native form submission.
      event.preventDefault();
  
      if (!stripe || !elements) {
        // Stripe.js has not loaded yet. Make sure to disable
        // form submission until Stripe.js has loaded.
        return;
      }
  
      // Get a reference to a mounted CardElement. Elements knows how
      // to find your CardElement because there can only ever be one of
      // each type of element.
      const cardElement = elements.getElement(CardElement);
  
      // Use your card Element with other Stripe.js APIs

 
   

      const {error, paymentMethod} = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
     
        
        
        
      });

      

      const payment = await stripes.paymentIntents.create({
       amount  : 1000,
        currency: "USD",
        description: "Spatula company",
        payment_method: paymentMethod,
        confirm: true
      })
      console.log("Payment", payment)

     
       
    
      if (error) {
        console.log('[error]', error);
      } else {
        console.log('[PaymentMethod]', paymentMethod);
      }
    };
  
    return (
      <form onSubmit={handleSubmit}>

        <GridContainer>

          <GridItem>
          <FormControl
                  style={{ width: mobileratio ? 267 : 450,marginRight:mobileratio?0:50  }}
                    variant="outlined"
                    className={classes.formControl}


                  >    <CardElement />   </FormControl>
          </GridItem>
        </GridContainer>
      
       <br></br>
       <br></br>
        <Button
        disabled={!stripe}
        onClick={registerEvent}
                  style={{
                    textTransform:"none",
                    width: mobileratio ? 267: Ipadpro?450 : 560,
                    backgroundColor: "#171942",
                    color:"white",
                    marginLeft:mobileratio?0:Ipadpro?0: 180
                  }}
                  >Pay</Button>
        {/* <button type="submit" disabled={!stripe}>
          Pay
        </button> */}
      </form>
    );
  };




  const CalculateRegistrationCost = (group,regday)=>{
    if(group==="13 And Under" && regday ==="Both"){
      costref.current.value=10
     
    }
    else if(group==="13 And Under" &&(regday ==="Saturday" || regday ==="Sunday" )){
      costref.current.value=5
      
    }
    else if(group==="14 And Over" && regday ==="Both"){
      costref.current.value=25
      
    }
    else if(group==="14 And Over" &&(regday ==="Saturday" || regday ==="Sunday" )){
      costref.current.value=15
      
    }
    else{
      costref.current.value=0
    }
    
  }
 
  const handleAgeGroupChange = (e) => {
    
    setAgeGroup(e.target.value);
    
   
    
  };

  const handleRegDaysChange = (e) => {
    
  
    setRegDays(e.target.value);
    
   
  };

  const handleRegDayClick=()=>{
    setInterval(()=>{
      CalculateRegistrationCost(agegroupref.current.value,regdayref.current.value)
    },1000)
    
  }

  const handleDOBChange = (date) => {
    setDOB(date);
  };

  const closeconfirmationbox = () => {
    setconfirmationbox(false);
    nameRef.current.value=""
  emailRef.current.value="" 
  addressRef.current.value=""
  phRef.current.value="" 
  costref.current.value=""
  
 

  };
  
  const displayErrormessage = () => {
    setErrormessage(false)
    nameRef.current.value=""
  emailRef.current.value="" 
  addressRef.current.value=""
  phRef.current.value="" 
  costref.current.value=""
  
 

  };

 

  return (
      <>
      <GridContainer>

    
        <GridItem>
          <div>
          <TextField
                  required
                  inputRef={nameRef}
                  value={ls.get("currentcustomer").displayName}
                  label="Name"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 450,marginRight:mobileratio?0:50 }}
                />
               {mobileratio?<br></br>:Ipadpro?<br></br>: null}
               {mobileratio?<br></br>:Ipadpro?<br></br>: null}
                <TextField
                  required
                  inputRef={emailRef}
                  label="Email"
                  variant="outlined"
                  value={ls.get("currentcustomer").email}
                  style={{ width: mobileratio ? 267 : 450 }}
                />

                <br></br>
                <br></br>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="start-date-picker"
                    label="Date of Birth"
                    inputVariant="outlined"
                    value={dob}
                    onChange={handleDOBChange}
                    style={{ width: mobileratio ? 267 : 450,marginRight:mobileratio?0:50  }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    required
                    //style={{ marginRight: 10 }}
                  />
                  
                </MuiPickersUtilsProvider>
                {mobileratio?<br></br>:null}
                {mobileratio?<br></br>:null}
                <TextField
                label={"Registration Fee"}
                  required
                  inputRef={costref}
                  variant="outlined"
                  defaultValue={0}
                  InputProps={{
                    readOnly: true,
                  }}
                  style={{ width: mobileratio ? 267 : 450, marginTop:mobileratio?0:15 }}
                />
                <br></br>
                <br></br>
                <FormControl
                  style={{ width: mobileratio ? 267 : 450,marginRight:mobileratio?0:50  }}
                    variant="outlined"
                    className={classes.formControl}
                    
                    required
                  >
                    <InputLabel id="event_label">Age Group</InputLabel>
                    <Select
                    inputRef={agegroupref}
                      labelId="age_group"
                      id="age_group"
                      value={ageGroup}
                      onChange={handleAgeGroupChange}
                      label="Age Group"
                    >
                      <MenuItem value="13 And Under">13 And Under</MenuItem>
                      <MenuItem value="14 And Over">14 And Over</MenuItem>
                    </Select>
                  </FormControl>
                  
                  {mobileratio ? <br></br> : Ipadpro?<br></br>: null}
                  {mobileratio ? <br></br> : Ipadpro?<br></br>: null}
                 
                  <FormControl
                  style={{ width: mobileratio ? 267 : 450 }}
                    variant="outlined"
                    className={classes.formControl}
                   
                    required
                  >
                    <InputLabel id="event_label">Registration Days</InputLabel>
                    <Select
                      labelId="registration_days"
                      id="registration_days"
                      inputRef={regdayref}
                      value={registrationDays}
                      onChange={handleRegDaysChange}
                      onClick={handleRegDayClick}
                      label="Registration Days"
                    >
                      <MenuItem value="Saturday">Saturday</MenuItem>
                      <MenuItem value="Sunday">Sunday</MenuItem>
                      <MenuItem value="Both">Both</MenuItem>
                    </Select>
                  </FormControl>
                  <br></br>
                <br></br>
                <TextField
                  required
                  inputRef={phRef}
                  label="Contact Number"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 450,marginRight:mobileratio?0:50 }}
                />
               {mobileratio?<br></br>:Ipadpro?<br></br>: null}
               {mobileratio?<br></br>:Ipadpro?<br></br>: null}
                <TextField
                  required
                  label="Address"
                  inputRef={addressRef}
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 450 }}
                />
                <br></br>
                <br></br>
                {/* <br></br>
                <h4 style={{color:"darkgray"}}>Card Details</h4>
                <br></br>
                <TextField
                  required
                  label="Card Holder Name"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 450,marginRight:mobileratio?0:50 }}
                />
               {mobileratio?<br></br>:Ipadpro?<br></br>: null}
               {mobileratio?<br></br>:Ipadpro?<br></br>: null}
                <TextField
                  required
                  label="Card Number"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 450 }}
                />

                <br></br>
                <br></br>
                <TextField
                  required
                  label="Expiry Date"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 450,marginRight:mobileratio?0:50 }}
                />
               {mobileratio?<br></br>:Ipadpro?<br></br>: null}
               {mobileratio?<br></br>:Ipadpro?<br></br>: null}
                <TextField
                  required
                  label="CVV"
                  variant="outlined"
                  style={{ width: mobileratio ? 267 : 450 }}
                />
                <br></br>
                <br></br>
                <Button
                style={{
                  textTransform:"none",
                  width: mobileratio ? 267: Ipadpro?450 : 560,
                  backgroundColor: "#171942",
                  color:"white",
                  marginLeft:mobileratio?0:Ipadpro?0: 180
                }}
                >Register</Button> */}
<br></br>




<Elements options={CARD_OPTIONS} stripe={stripePromise} >
      <CheckoutForm />
    </Elements>
          </div>
        </GridItem>

                <GridItem>
                <div>
       
          </div>
                </GridItem>
       
      </GridContainer>


      <Dialog
        open={confirmationbox}
        onClose={closeconfirmationbox}
      >
        <DialogTitle >
          Your Event Registration has been completed succesfully!  
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button onClick={closeconfirmationbox} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={errormessage}
        onClose={displayErrormessage}
      >
        <DialogTitle >
         Please Specify all the required fields
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button onClick={displayErrormessage} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      </>



  )
  
}
export default EventRegistration;
